import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import Button from '@amzn/meridian/button'
import Column from '@amzn/meridian/column'
import { AtHeader } from '@amzn/ihm-associate-tools-meridian-components'
import { EnvironmentDetail } from '@amzn/ihm-associate-tools-js-lib'

import { UserTypeService } from './utils/UserTypeService'

import { useBundle } from '@amzn/react-arb-tools'
import { BUNDLE_NAME } from '@src/constants'
import { t } from '@src/translationHelper'
import ATLoader from '@src/components/ATLoader'

const UserTypeSelectionPage = (props) => {
    const navigate = useNavigate()
    const [bundle, isBundleLoading] = useBundle(BUNDLE_NAME)
    EnvironmentDetail.getDevicePlatform()
    const setUserType = (userType: string) => {
        console.debug('Setting user type', userType)
        UserTypeService.setUserType(userType)
        navigate('/store-id-selection')
    }

    const userTypes = UserTypeService.getAvailableUserTypes()

    useEffect(() => {
        if (userTypes.length === 1) {
            setUserType(userTypes[0])
        }
    }, [])

    const userTypesButtons = []

    userTypes.forEach((userType: string) => {
        userTypesButtons.push(
            <Button onClick={() => { setUserType(userType) }}> {userType} </Button>,
        )
    })

    if (isBundleLoading) {
        return <ATLoader />
    }

    return (
        <Column spacing={'medium'}>
            <AtHeader title={t(bundle, 'ihm-associatetoolsbase-select-user-type')} goBack={() => { return }}/>
            <Column spacingInset="medium">
                {userTypesButtons}
            </Column>
        </Column>
    )
}

export default UserTypeSelectionPage
